<div *ngIf="selectedUnit === 1">
  <h3 class="title s-16 mb-16">
    Datasheet <span class="text"> Frequency/Duration Based Datasheet</span>
  </h3>
  <div class="custom-data-wrapper mb-16">
    <div class="data">
      <p class="text">
        Option 1: Click 'Freq. Only' to record Frequency totals for specific
        time intervals within a day.
      </p>
    </div>
    <div class="data">
      <p class="text">
        Option 2: Click 'Duration' to record Frequency w/ Duration Data for
        specific time intervals within a day.
      </p>
    </div>
    <div class="data">
      <p class="text">
        Option 3: Click 'Modify' to record the daily total frequency for one or
        more days.
      </p>
    </div>
  </div>
  <p class="error-text mb-24">
    If no behavior occurred, record a zero. If absent, leave blank.
  </p>
</div>

<div *ngIf="selectedUnit === 3">
  <h3 class="title s-16 mb-16">
    Datasheet <span class="text"> Partial Interval</span>
  </h3>
  <span>
    <h3 class="title s-16 mb-16">Instructions:</h3>
  </span>
  <div class="custom-data-wrapper mb-16">
    <div class="data">
      <p class="text">Click 'Enter Data' to record Partial Interval.</p>
    </div>

    <div class="data">
      <p class="text">
        Each interval (1,2,3) represents a 10 minute duration where the behavior
        is closely monitored. For each minute of the interval, if the behavior
        occurs, record a 1. At the end of the 10 minute interval calculate the
        total number of times the behavior occurred.
      </p>
    </div>
  </div>

  <p class="error-text mb-24">
    Note: The total for each interval should not exceed 10.
  </p>
</div>

<div *ngIf="selectedUnit === 2">
  <h3 class="title s-16 mb-16">Datasheet <span class="text"> Latency</span></h3>
  <span>
    <h3 class="title s-16 mb-16">Instructions:</h3>
  </span>
  <div class="custom-data-wrapper mb-16">
    <div class="data">
      <p class="text">
        Click 'Enter Data' to record Latency for specific time intervals within
        a day.
      </p>
    </div>
    <div class="data">
      <p class="text">
        Document the duration(mins) from when the direction was given to the
        student to the end time as when the student begins the task or follow
        directions.
      </p>
    </div>
  </div>
  <p class="error-text mb-24">
    If no behavior occurred, record a zero. If absent, leave blank.
  </p>
</div>
<div *ngIf="selectedUnit === 4">
  <h3 class="title s-16 mb-16">
    Datasheet <span class="text"> Replacement Behavior</span>
  </h3>
  <span>
    <h3 class="title s-16 mb-16">Instructions:</h3>
  </span>
  <div class="custom-data-wrapper mb-16">
    <div class="data">
      <p class="text">
        Click 'Enter Data' to record the frequency of the Replacement Behvior
        for specific time intervals within a day.
      </p>
    </div>

    <div class="data">
      <p class="text">
        Document the numeric value for each time the behavior occurs during the
        time period it occurred.
      </p>
    </div>
  </div>

  <p class="error-text mb-24">
    If no behavior occurred, record a zero. If absent, leave blank.
  </p>
</div>
